export const TEST_ID_ANSWER_REVIEW_CONTENT = 'TEST_ID_ANSWER_REVIEW_CONTENT';
export const TEST_ID_ANSWERED_AT_REVIEW_CONTENT =
  'TEST_ID_ANSWERED_AT_REVIEW_CONTENT';
